import { Component, EventEmitter, Input, Output, inject, OnChanges } from '@angular/core';
import { BrandChipComponent } from './brand-chip/brand-chip.component';
import { CommonModule } from '@angular/common';
import { SelectBrandItem } from '../../services/dashboard.service';
import { BrandChipAddButtonComponent } from './brand-chip-add-button/brand-chip-add-button.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatTooltip } from '@angular/material/tooltip';
import { tooltips } from '../../utils/tooltips';
import { NO_COMPETITORS_ASSIGNED } from '../../utils/constants';
import { DataTestIds } from '../../../../e2e/types';

@Component({
  selector: 'app-brands-selection-panel',
  imports: [
    BrandChipComponent,
    CommonModule,
    BrandChipAddButtonComponent,
    MatTooltip,
  ],
  templateUrl: './brands-selection-panel.component.html',
  styleUrl: './brands-selection-panel.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9)' }),
        animate('300ms ease-in-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ opacity: 0, transform: 'scale(0.9)' }))
      ])
    ])
  ]
})
export class BrandsSelectionPanelComponent {
  @Input() isTrialUser: boolean = false;
  @Input() displayUserRelatedBrand: boolean = false;
  @Input() isMyCompetitorsDisabled: boolean = false;
  @Input() shouldDisplayAddButton: boolean = false;
  @Input() shouldDisplayRemoveButton: boolean = false;

  @Input() myBrand?: SelectBrandItem;
  @Input() myCompetitors?: SelectBrandItem[];
  @Input() myBrandOptions?: SelectBrandItem[];
  @Input() myCompetitorsOptions?: SelectBrandItem[];
  @Input() userRelatedBrand?: SelectBrandItem;
  @Input() userRelatedBrandOptions?: SelectBrandItem[];

  @Output() brandChanged = new EventEmitter<string>();
  @Output() competitorChanged = new EventEmitter<{ competitorKey: string, previousCompetitorKey: string }>();
  @Output() competitorAdded = new EventEmitter<string>();
  @Output() competitorRemoved = new EventEmitter<string>();
  @Output() userRelatedBrandChanged = new EventEmitter<string>();

  protected readonly tooltips = tooltips.shared.brandsSelectionPanel;
  protected readonly NO_COMPETITORS_ASSIGNED = NO_COMPETITORS_ASSIGNED;
  protected readonly DataTestIds = DataTestIds;

  onMyBrandChanged(brandKey: string): void {
    this.brandChanged.emit(brandKey);
  }

  onCompetitorChanged(competitorKey: string, previousCompetitorKey: string): void {
    this.competitorChanged.emit({competitorKey, previousCompetitorKey});
  }

  onCompetitorRemoved(competitorKey: string): void {
    this.competitorRemoved.emit(competitorKey);
  }

  onCompetitorAdded(competitorKey: string): void {
    this.competitorAdded.emit(competitorKey);
  }

  onUserRelatedBrandChanged(brandKey: string): void {
    this.userRelatedBrandChanged.emit(brandKey);
  }
}
